import { SignalDocumentGroup } from "./groupSignals";
import { SignalDocumentTile } from "./SignalDocumentTile";

type Props = {
  items: SignalDocumentGroup[];
  onRowNavigate: (href: string, group: SignalDocumentGroup) => void;
};

export const AllSignalsList: React.FC<Props> = ({ items, onRowNavigate }) => {
  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.625rem", width: "100%", marginBottom: "1rem" }}>
      {items.map((group) => (
        <SignalDocumentTile key={group.key} group={group} onNavigate={onRowNavigate} />
      ))}
    </div>
  );
};
